export enum IncidentTypeValue {
    Missing = "MIS",
    Damaged = "DAM",
    Technical = "TEC",
    Data = "DAT"
}
